/**
 * @fileoverview Toast notification validation.
 */

import type { ToastType } from "../types";
import type { ValidationResult, ToastValidationInput } from "./types";

const VALID_TOAST_TYPES: ToastType[] = ["success", "error", "warning", "info"];

/**
 * Validate toast notification options.
 */
export function validateToast(options: ToastValidationInput): ValidationResult {
  const errors: string[] = [];

  // Type validation
  if (options.type === undefined || options.type === null) {
    errors.push("Toast type is required");
  } else if (
    typeof options.type !== "string" ||
    !VALID_TOAST_TYPES.includes(options.type as ToastType)
  ) {
    errors.push(
      `Invalid toast type "${options.type}". Expected: ${VALID_TOAST_TYPES.join(" | ")}`,
    );
  }

  // Message validation
  if (options.message === undefined || options.message === null) {
    errors.push("Toast message is required");
  } else if (typeof options.message !== "string") {
    errors.push("Toast message must be a string");
  } else if (options.message.trim() === "") {
    errors.push("Toast message cannot be empty");
  }

  // Duration validation (optional)
  if (options.duration !== undefined && options.duration !== null) {
    if (typeof options.duration !== "number") {
      errors.push("Toast duration must be a number");
    } else if (options.duration < 0) {
      errors.push("Toast duration cannot be negative");
    }
  }

  return { valid: errors.length === 0, errors };
}
